import ISO8601 from '@square/dashboard-data/models/squareup/bills/iso8601-date';
import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
export default ProtoBaseModel.extend({
  settlementToken: attr(String),
  settlementCreatedAt: attr(ISO8601)
});